import React from 'react';

const GroupOnlyTemporaryIcon = () => (
    <svg
        className="visibility"
        viewBox="0 0 24 24"
        fill="none"
        width="24"
        height="24"
    >
        <path
            d="M9 11C10.1 11 11.1833 11.1294 12.25 11.3877C12.4721 11.4415 12.6934 11.5014 12.9141 11.5664C11.1418 12.9382 10 15.0854 10 17.5C10 17.6681 10.0077 17.8347 10.0186 18H3C2.45 18 1.97956 17.8038 1.58789 17.4121C1.19622 17.0204 1 16.55 1 16V15.2002C1 14.6336 1.14589 14.1127 1.4375 13.6377C1.72912 13.1628 2.11638 12.7998 2.59961 12.5498C3.63293 12.0331 4.68335 11.646 5.75 11.3877C6.81667 11.1294 7.9 11 9 11Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            d="M9 2C10.1 2 11.0419 2.39147 11.8252 3.1748C12.6085 3.95814 13 4.9 13 6C13 7.1 12.6085 8.04186 11.8252 8.8252C11.0419 9.60853 10.1 10 9 10C7.9 10 6.95814 9.60853 6.1748 8.8252C5.39147 8.04186 5 7.1 5 6C5 4.9 5.39147 3.95814 6.1748 3.1748C6.95814 2.39147 7.9 2 9 2Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            d="M15 2C16.1 2 17.0419 2.39147 17.8252 3.1748C18.6085 3.95814 19 4.9 19 6C19 7.1 18.6085 8.04186 17.8252 8.8252C17.0419 9.60853 16.1 10 15 10C14.8167 10 14.5831 9.97917 14.2998 9.9375C14.0166 9.89584 13.7829 9.84979 13.5996 9.7998C14.0495 9.26655 14.396 8.67528 14.6377 8.02539C14.8794 7.37539 15 6.7 15 6C15 5.3 14.8794 4.62461 14.6377 3.97461C14.396 3.32472 14.0495 2.73345 13.5996 2.2002C13.8329 2.11688 14.0665 2.06212 14.2998 2.03711C14.5331 2.01211 14.7667 2 15 2Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
        <path
            d="M13.6088 21.3913C12.5363 20.3188 12 19.0217 12 17.5C12 15.9783 12.5363 14.6813 13.6088 13.6088C14.6813 12.5363 15.9783 12 17.5 12C19.0217 12 20.3188 12.5363 21.3913 13.6088C22.4638 14.6813 23 15.9783 23 17.5C23 19.0217 22.4638 20.3188 21.3913 21.3913C20.3188 22.4638 19.0217 23 17.5 23C15.9783 23 14.6813 22.4638 13.6088 21.3913ZM18.05 17.28V14.75C18.05 14.6033 17.995 14.475 17.885 14.365C17.775 14.255 17.6467 14.2 17.5 14.2C17.3533 14.2 17.225 14.255 17.115 14.365C17.005 14.475 16.95 14.6033 16.95 14.75V17.2525C16.95 17.3992 16.9775 17.5413 17.0325 17.6788C17.0875 17.8163 17.17 17.94 17.28 18.05L18.93 19.7C19.04 19.81 19.1683 19.865 19.315 19.865C19.4617 19.865 19.59 19.81 19.7 19.7C19.81 19.59 19.865 19.4617 19.865 19.315C19.865 19.1683 19.81 19.04 19.7 18.93L18.05 17.28Z"
            fill="currentColor"
            fillOpacity="0.72"
        />
    </svg>
);

export default GroupOnlyTemporaryIcon;
